import { size } from 'lodash';

export const ProgressBar = {
  bindings: {
    weeks: '<',
    percentage: '<',
    imgSrc: '<',
  },

  template: `
    <div class="progress-bar">
      <ol class="progress-bar-steps">
        <li class="step"
          ng-class="{ 'active': $ctrl.isStepActive(0) }">
          <div class="step-icon"></div>
        </li>
        <li class="step"
          ng-class="{ 'active': $ctrl.isStepActive(week.weekNumber) }"
          ng-repeat="week in $ctrl.weeks track by $index">
          <div class="step-icon"></div>
        </li>
      </ol>
      <div class="progress-bar-line">
        <div class="line" ng-style="{ width: $ctrl.percentage + '%' }"></div>
        <div class="line-bg"></div>
        <div class="line-avatar"
          ng-style="{ left: $ctrl.percentage + '%' }">
          <image-circle src="$ctrl.imgSrc"></image-circle>
        </div>
      </div>
    </div>`,

  controller() {
    return {
      isStepActive(step) {
        return this.percentage >= step / size(this.weeks) * 100;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Progress/ProgressBar.js